import React, {useState, useEffect} from 'react';
import * as S from './KycInfo.styles';
import * as C from '../Common.styles';

import getPincodeInfo from '@ibibo/get-pincode-info';

import {validations} from '../../../../utils/validations';
import ButtonLoader from '../../UI/Loader/Loader';
import {NON_EDITABLE_STATUS} from '../../../../constants';
import {IKYCData} from '../../../../store/types';
import {sendEvarData} from '@ibibo/analytics';

import {UploadFile, UploadInfo, UploadKycDoc, UploadRefresh, UploadFacadeDoc} from '../../UI/UploadBlock/UploadFile';

import {PanUploader, KYCUploader, FacadeUploader, NameCorrectSelect} from '../../UI/PanUploader/PanUploader';

const KycInfoUI = ({
  data,
  error,
  status,
  submitDetails,
  cancelPAN,
  onUpload,
  uploadKYC,
  uploadFacade,
  businessTypeList,
  kycDocList,
  setLoader,
  gstLoader,
  addDocList
}) => {
  const [
    {
      agencyName,
      panNumber,
      panUploaded,
      panInfo,
      businessType,
      address,
      state,
      city,
      pincode,
      gstNumber,
      kycDocType,
      kycUploaded,
      panVerified,
      facadeUploaded,
      panSuccess,
      pan_name,
      pan_type,
      user_msg,
      additionalDoc,
    },
    setDetails,
  ] = useState({
    agencyName: data.agencyName || '',
    panNumber: data.panNumber || '',
    panUploaded: data.panUploaded || false,
    panInfo: data.panInfo || null,
    businessType: data.businessType || '',
    address: data.address || '',
    state: data.state || '',
    city: data.city || '',
    pincode: data.pincode || '',
    gstNumber: data.gstNumber || '',
    kycDocType: data.kycDocType || '',
    kycUploaded: data.kycUploaded || '',
    panVerified: data.panVerified || false,
    facadeUploaded: data.facadeUploaded || '',
    panSuccess: data.panSucces || false,
    pan_name: data.pan_name || '',
    pan_type: data.pan_type || false,
    user_msg: data.user_msg || '',
    additionalDoc: data.additionalDoc || ''
  });

  const [apiErrorMsg, setApiError] = useState(error);
  const [pincodeDataLoading, setPincodeDataLoading] = useState(false);
  const [errors, setError] = useState({});
  const [doNotHaveGSTIN, setDoNotHaveGSTIN] = useState(
    data.panUploaded && data.gstNumber === '' && !panInfo ? true : false,
  );

  const [disabelCity, setDisableCity] = useState(false);

  const [popVisible, setPopVisible] = useState(false);
  const [popKycVisible, setPopKycVisible] = useState(false);
  const [popFacadeVisible, setPopFacadeVisible] = useState(false);
  const [fileUrl, setFileUrl] = useState('');

  const [nameCorrectPop, setNameCorrectPop] = useState(true);


  useEffect(() => {
    setApiError(error);
  }, [error]);

  useEffect(() => {
    setDoNotHaveGSTIN(data.panUploaded && data.gstNumber === '' && !data.panInfo ? true : false);
  }, [data.panUploaded, data.gstNumber]);

  useEffect(() => {
    setDetails({
      agencyName: data.agencyName || agencyName,
      panNumber: data.panNumber || panNumber,
      panUploaded: data.panUploaded || panUploaded,
      panInfo: data.panInfo || panInfo,
      businessType: data.businessType || businessType,
      address: data.address || address,
      state: data.state || state,
      city: data.city || city,
      pincode: data.pincode || pincode,
      gstNumber: data.gstNumber || gstNumber,
      kycDocType: data.kycDocType || kycDocType,
      kycUploaded: data.kycUploaded || kycUploaded,
      panVerified: data.panVerified || panVerified,
      facadeUploaded: data.facadeUploaded || facadeUploaded,
      panSuccess: data.panSuccess || panSuccess,
      pan_name: data.pan_name || pan_name,
      pan_type: data.pan_type || pan_type,
      user_msg: data.user_msg || user_msg,
      additionalDoc: data.additionalDoc || additionalDoc
    });
  }, [data]);

  useEffect(() => {
    if (!data.panUploaded) {
      setDetails({
        agencyName: agencyName,
        panNumber: panNumber,
        panUploaded: false,
        panInfo: null,
        businessType: '',
        address: '',
        state: '',
        city: '',
        pincode: '',
        gstNumber: '',
        kycDocType: '',
        kycUploaded: false,
        panVerified: false,
        facadeUploaded: false,
        panSuccess: false,
        pan_name: '',
        pan_type: false,
        user_msg: '',
        additionalDoc: ''
      });
    }
  }, [data.panUploaded]);


  useEffect(() => {
    setDetails({
      agencyName: agencyName,
      panNumber: panNumber,
      panUploaded: panUploaded,
      panInfo: panInfo,
      businessType: businessType,
      address: address,
      state: state,
      city: city,
      pincode: pincode,
      gstNumber: doNotHaveGSTIN ? '' : gstNumber,
      kycDocType: kycDocType,
      kycUploaded: kycUploaded,
      panVerified: panVerified,
      facadeUploaded: facadeUploaded,
      panSuccess: panSuccess,
      pan_name: pan_name,
      pan_type: pan_type,
      user_msg: user_msg,
      additionalDoc: additionalDoc
    });
  }, [doNotHaveGSTIN]);


  useEffect(() => {
    if (!gstLoader && !data.panUploaded) {
      clearUploadData();
    }
  }, [gstLoader]);

  const fieldValidators = {
    agencyName: {fieldName: 'Agency Name', validators: ['required', 'validAddress']},
    panNumber: {fieldName: 'PAN', validators: ['required', 'validPAN']},
    businessType: {fieldName: 'Business Type', validators: ['required']},
    address: {fieldName: 'Address', validators: ['required', 'validAddress']},
    state: {fieldName: 'State', validators: ['required']},
    city: {fieldName: 'City', validators: ['required']},
    pincode: {fieldName: 'Pincode', validators: ['required', 'validPincode']},
    gstNumber: {fieldName: 'GST Number', validators: []},
    kycDocType: {fieldName: 'KYC Document Type', validators: []},
    kycDoc: {fieldName: 'KYC Document', validators: []},
    facadeDoc: {fieldName: 'Facade Document', validators: []},
    panDoc: {fieldName: 'PAN Document', validators: ['required']},
    additionalDoc: {fieldName: 'Additional KYC Document Type', validators: []},
  };

  const [{fileSize, fileName, sizeError, fileSuccess, upload}, setFileInfo] = useState({
    fileSize: 0,
    fileName: '',
    sizeError: null,
    fileSuccess: true,
    upload: false,
  });

  const [
    {kycfileSize, kycfileName, kycsizeError, kycfileSuccess, kycupload},
    setKycFileInfo,
  ] = useState({
    kycfileSize: 0,
    kycfileName: '',
    kycsizeError: null,
    kycfileSuccess: true,
    kycupload: false,
  });

  const [
    {facadefileSize, facadefileName, facadesizeError, facadefileSuccess, facadeupload},
    setFacadeFileInfo,
  ] = useState({
    facadefileSize: 0,
    facadefileName: '',
    facadesizeError: null,
    facadefileSuccess: true,
    facadeupload: false,
  });

  const [{tooltipAgency, tooltipPan}, setToolTip] = useState({
    tooltipAgency: false,
    tooltipPan: false,
  });

  const [showClose, setShowClose] = useState(false);

  const [panFile, setPanFile] = useState({
    panFile: {}
  })

  const getHasGSTN = (list) => {
    for (let i = 0; i < list.length; i++) {
      if (list[i].active_status === 'Active') {
        return true;
      }
    }
    return false;
  }

  const [showName, setShowName] = useState(false);

  const successCallBack = (resp) => {
    if(resp.pan_name){
      setShowName(true);
    }
  }

  // const isGSTBlockEnabled = agencyName !== '' && panNumber !== '' && panUploaded ? true : false;
  const isGSTBlockEnabled = true;
  let isUploadPanEnabled = agencyName !== '' && panNumber !== '' ? true : false;
  const hasGSTINList = panInfo && panInfo.gstin_list && panInfo.gstin_list.length ? getHasGSTN(panInfo.gstin_list) : false;
  let showKYC = (!hasGSTINList || doNotHaveGSTIN) && isGSTBlockEnabled ? true : false;
  if (NON_EDITABLE_STATUS.indexOf(status) !== -1) {
    showKYC = kycDocType !== '';
  }

  const validateFields = data => {
    let errorObj = {};
    if (showKYC) {
      fieldValidators.kycDocType.validators.push('required');
      fieldValidators.kycDoc.validators.push('required');
      fieldValidators.facadeDoc.validators.push('required');
      fieldValidators.additionalDoc.validators.push('required');
    }
    if (!doNotHaveGSTIN) {
      fieldValidators.gstNumber.validators.push('required');
      fieldValidators.gstNumber.validators.push('validGSTNumber');
    }
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const resp = validateFunction({
            value: data[key],
            fieldName: fieldValidators[key].fieldName
          });
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  };

  const submitInfo = (event: React.FormEvent) => {
    event.preventDefault();
    let dataObj: IKYCData = {
      agencyName,
      panNumber,
      panDoc: panUploaded,
    };
    if (panUploaded) {
      dataObj = {
        agencyName,
        panNumber,
        panDoc: panUploaded,
        gstNumber,
        businessType,
        address,
        state,
        city,
        pincode,
        kycDocType,
        kycDoc: kycUploaded,
        facadeDoc: facadeUploaded,
        additionalDoc: additionalDoc
      };
    }
    const hasError = validateFields(dataObj);
    if (!hasError) {
      submitDetails(dataObj);
    }
    sendEvarData({
      prop54: "myPartner|signup|businessVerification|next"
    }, true)
  };

  const uploadPanNumber = (correctName = false) => {
    const panFileSize = panFile.size / 1024 / 1024;
    if (panFileSize < 5) {
      setFileInfo({
        fileSize: panFileSize,
        fileName: panFile.name,
        sizeError: null,
        fileSuccess: false,
        upload: false,
      });

      onUpload({panNumber, agencyName: (correctName ? pan_name : agencyName ) , panFile, successCallBack});
    } else {
      setFileInfo({
        fileSize: panFileSize,
        fileName: panFile.name,
        sizeError: 'File size must be less than 5MB',
        fileSuccess: true,
        upload: false,
      });
    }
    setNameCorrectPop(true);
  };

  const showUploadPan = () => {
    const panTest = document.getElementById('panUpload').files[0];
    setPanFile(panTest);
    if(!popVisible){
      const urlShow = URL.createObjectURL(document.getElementById('panUpload').files[0]);
      setFileUrl(urlShow);
      setPopVisible(true);
    }
  }

  const showKycUpload = () => {
    if(!popKycVisible){
      const urlShow = URL.createObjectURL(document.getElementById('uploadKYCDoc').files[0]);
      setFileUrl(urlShow);
      setPopKycVisible(true);
    }
  }

  const showFacadeUpload = () => {
    if(!popFacadeVisible){
      const urlShow = URL.createObjectURL(document.getElementById('uploadFacadeDoc').files[0]);
      setFileUrl(urlShow);
      setPopFacadeVisible(true);
    }
  }

  const uploadDocument = () => {
    if (!kycDocType) {
      errors['kycDocType'] = 'Required';
      setError(errors);
      return;
    }
    let kycFile = document.getElementById('uploadKYCDoc').files[0];
    const kycFileSize = kycFile.size / 1024 / 1024;
    if (kycFileSize < 5) {
      setKycFileInfo({
        kycfileSize: kycFileSize,
        kycfileName: kycFile.name,
        kycsizeError: null,
        kycfileSuccess: false,
        kycupload: false,
      });
      uploadKYC({kycFile, kycDocType});
    } else {
      setKycFileInfo({
        kycfileSize: kycFileSize,
        kycfileName: kycFile.name,
        kycsizeError: 'File size must be less than 5MB',
        kycfileSuccess: true,
        kycupload: false,
      });
    }
  };

  const Uploadfacade = () => {
    let facadeFile = document.getElementById('uploadFacadeDoc').files[0];
    const facadeFileSize = facadeFile.size / 1024 / 1024;
    if (facadeFileSize < 5) {
      setFacadeFileInfo({
        facadefileSize: facadeFileSize,
        facadefileName: facadeFile.name,
        facadesizeError: null,
        facadefileSuccess: false,
        facadeupload: false,
      });
      uploadFacade({facadeFile});
    } else {
      setFacadeFileInfo({
        facadefileSize: facadeFileSize,
        facadefileName: facadeFile.name,
        facadesizeError: 'File size must be less than 5MB',
        facadefileSuccess: true,
        facadeupload: false,
      });
    }
  }

  const onPincodeBlur = async (key, val) => {
    let errorObj = {};
    if (fieldValidators[key]) {
      const validators = fieldValidators[key].validators;
      for (let i = 0; i < validators.length; i++) {
        const validateFunction = validations[validators[i]];
        const resp = validateFunction({
          value: val,
          fieldName: fieldValidators[key].fieldName
        });
        if (resp && !errorObj[key]) {
          errorObj[key] = resp;
        }
      }
    }
    if (!Object.keys(errorObj).length) {
      setPincodeDataLoading(true);
      const resp = await getPincodeInfo(val);
      if (resp) {
        const dataObj = {
          agencyName,
          panNumber,
          panUploaded,
          panInfo,
          gstNumber,
          businessType,
          address,
          city: resp?.data?.District || '',
          state: resp?.data?.StateName || '',
          pincode,
          kycDocType,
          facadeUploaded,
          additionalDoc
        };
        setDetails(dataObj);
        setPincodeDataLoading(false);
      }
      if(resp.success){
        setDisableCity(true);
      }
      if(!resp.success){
        setDisableCity(false);
      }
    }
  }

  const onChangeHandler = (field, value) => {
    if (field === 'pincode') {
      const re = /^[0-9]+$/;
      if (value !== '' && !re.test(value)) {
        return;
      }
    }

    if (field === "businessType") {
      sendEvarData({
        prop54: `myPartner|signup|businessVerification|BusinessType|${value}`
      }, true)
    }
    else if (field === "kycDocType") {
      sendEvarData({
        prop54: `myPartner|signup|businessVerification|KYCDocumentType|${value}`
      }, true)
    }
    else if (field === "additionalDoc") {
      sendEvarData({
        prop54: `myPartner|signup|businessVerification|AdditionalKYCDocumentType|${value}`
      }, true)
    }

    const dataObj = {
      agencyName,
      panNumber,
      panUploaded,
      panInfo,
      gstNumber,
      businessType,
      address,
      state,
      city,
      pincode,
      kycDocType,
      kycUploaded,
      panSuccess,
      pan_name,
      pan_type,
      user_msg,
      facadeUploaded,
      additionalDoc
    };
    dataObj[field] = value;
    setDetails(dataObj);
  };

  const toggleCheckBox = event => {
    let evarStr = ""
    const isChecked = event.target.checked;
    if (isChecked) {
      setDoNotHaveGSTIN(true);
      evarStr = "myPartner|signup|businessVerification|GSTN|checked"
    } else {
      setDoNotHaveGSTIN(false);
      evarStr = "myPartner|signup|businessVerification|GSTN|unchecked"
    }
    sendEvarData({
      prop54: evarStr
    }, true)
  };

  const GSTINSlectBox = ({list}) => (
    <C.CommonSelect
      value={gstNumber}
      onChange={event => onChangeHandler('gstNumber', event.target.value)}
      hasError={errors['gstNumber'] ? true : false}
    >
      <option value="" disabled hidden>
        Select GST Number
      </option>
      {list.map(item => {
        if (item.active_status === 'Active') {
          return (
            <option key={item.gstin} value={item.gstin}>
              {item.gstin} {item.state}
            </option>
          );
        }
        return null;
      })}
    </C.CommonSelect>
  );

  const BusinessTypeSelect = () => (
    <C.CommonSelect
      onChange={event => onChangeHandler('businessType', event.target.value)}
      value={businessType}
      hasError={errors['businessType'] ? true : false}
    >
      <option value="" disabled hidden>
        Select Business Type
      </option>
      {Object.keys(businessTypeList).map(key => (
        <option key={key} value={key}>
          {businessTypeList[key]}
        </option>
      ))}
    </C.CommonSelect>
  );

  const KYCDocTypeSelect = () => (
    <C.CommonSelect
      onChange={event => onChangeHandler('kycDocType', event.target.value)}
      value={kycDocType}
      hasError={errors['kycDocType'] ? true : false}
    >
      <option value="" disabled hidden>
        Select KYC Document Type
      </option>
      {Object.keys(kycDocList).map(key => (
        <option key={key} value={key}>
          {kycDocList[key]}
        </option>
      ))}
    </C.CommonSelect>
  );

  const AdditionalKYCDocTypeSelect = () => (
    <C.CommonSelect
      onChange={event => onChangeHandler('additionalDoc', event.target.value)}
      value={additionalDoc}
      hasError={errors['additionalDoc'] ? true : false}
    >
      <option value="" disabled hidden>
        Select Additonal KYC Document Type
      </option>
      {Object.keys(addDocList).map(key => (
        <option key={key} value={key}>
          {addDocList[key]}
        </option>
      ))}
    </C.CommonSelect>
  );

  const clearUploadData = () => {
    sendEvarData({
      prop54: "myPartner|signup|businessVerification|removeDocument|PAN"
    }, true)
    setFileInfo({fileSize: null, fileName: null, sizeError: null, fileSuccess: true, upload: true});
    isUploadPanEnabled = false;

    setToolTip({tooltipAgency: false, tooltipPan: false});
  };

  const clearKycUploadData = () => {
    sendEvarData({
      prop54: "myPartner|signup|businessVerification|removeDocument|KYC"
    }, true)
    
    setKycFileInfo({
      kycfileSize: null,
      kycfileName: null,
      kycsizeError: null,
      kycfileSuccess: true,
      kycupload: true,
    });
  };

  const clearFacadeUploadData = () => {
    sendEvarData({
      prop54: "myPartner|signup|businessVerification|removeDocument|facade"
    }, true)

    setFacadeFileInfo({
      facadefileSize: null,
      facadefileName: null,
      facadesizeError: null,
      facadefileSuccess: true,
      facadeupload: true,
    });
  };

  const clearAddDocUploadData = () => {
    sendEvarData({
      prop54: "myPartner|signup|businessVerification|removeDocument|Additional"
    }, true)
    setAddDocInfo({
      addDocsize: null,
      addDocName: null,
      addDocSizeError: null,
      addDocSuccess: null,
      addDocUploaded: null
    });
  }

  const resetUpload = () => {
    clearUploadData();
    cancelPAN();
  };

  const resetKycUpload = () => {
    clearKycUploadData();
  };

  if (status === 'confirmed') {
    setShowClose(false);
  }

  let uploadBlock = (
    <S.KycLabelWrap>
      <UploadFile change={showUploadPan} toDisabled={!isUploadPanEnabled} />
      {sizeError !== '' ? <C.ErrorText>{sizeError}</C.ErrorText> : ''}
      <C.ErrorText>{errors['panDoc']}</C.ErrorText>
    </S.KycLabelWrap>
  );
  if (!fileSuccess) {
    uploadBlock = <UploadInfo filesize={fileSize} filename={fileName} reset={resetUpload} />;
  }

  if (panUploaded && (!fileName || fileName === '')) {
    uploadBlock = <UploadRefresh reset={resetUpload} close={showClose} />;
  }

  let kycUpload = (
    <S.KycLabelWrap>
      <UploadKycDoc change={showKycUpload} />
      <C.ErrorText>{errors['kycDoc']}</C.ErrorText>
    </S.KycLabelWrap>
  );
  if (!kycfileSuccess) {
    kycUpload = <UploadInfo filesize={kycfileSize} filename={kycfileName} reset={resetKycUpload} />;
  }

  if (kycDocType !== '' && (!fileName || fileName === '')) {
    kycUpload = <UploadRefresh reset={resetKycUpload} close={showClose} />;
  }

  let facadeUpload = (
    <S.KycLabelWrap>
      <UploadFacadeDoc change={showFacadeUpload} />
      <C.ErrorText>{errors['facadeDoc']}</C.ErrorText>
    </S.KycLabelWrap>
  );

  if (!facadefileSuccess) {
    facadeUpload = <UploadInfo filesize={facadefileSize} filename={facadefileName} reset={clearFacadeUploadData} />;
  }

  if (facadeUploaded && (!fileName || fileName === '')) {
    facadeUpload = <UploadRefresh reset={clearFacadeUploadData} close={showClose} />;
  }

  let EditToolTip = <S.InfoToolTip>Please remove pan card to edit.</S.InfoToolTip>;

  const onAgencyClick = () => {
    if (!upload) {
      setToolTip({tooltipAgency: !tooltipAgency, tooltipPan: false});
    }
  };

  const onPanClick = () => {
    if (!upload) {
      setToolTip({tooltipAgency: false, tooltipPan: !tooltipPan});
    }
  };

  const cancelEvent = () => {
    setPopVisible(false);
    resetUpload();
    setFileUrl('');
  }

  const cancelKycEvent = () => {
    setPopKycVisible(false);
    resetKycUpload();
    setFileUrl('');
  }

  const cancelFacadeEvent = () => {
    setPopFacadeVisible(false);
    clearFacadeUploadData();
    setFileUrl('');
  }


  const agreeEvent = () => {
    sendEvarData({
      prop54: "myPartner|signup|businessVerification|docPreview|PAN"
    }, true)
    setPopVisible(false);
    uploadPanNumber();
    setFileUrl('');
  }

  const agreeKycEvent = () => {
    sendEvarData({
      prop54: "myPartner|signup|businessVerification|docPreview|Supporting"
    }, true)
    setPopKycVisible(false);
    uploadDocument();
    setFileUrl('');
  }

  const agreeFacadeEvent = () => {
    sendEvarData({
      prop54: "myPartner|signup|businessVerification|docPreview|Facade"
    }, true)
    setPopFacadeVisible(false);
    Uploadfacade();
    setFileUrl('');
  }

  const cancelPanNameEvent = () => {
    setNameCorrectPop(false);
    setShowName(false);
    resetUpload();
    setDetails({
      agencyName,
      panNumber,
      panUploaded,
      panInfo,
      businessType,
      address,
      state,
      city,
      pincode,
      gstNumber,
      kycDocType,
      kycUploaded,
      panVerified,
      facadeUploaded,
      panSuccess,
      pan_name,
      pan_type: false,
      user_msg,
      additionalDoc
    });
  }

  const agreeNameEvent = () => {
    if(!pan_type){
      setDetails({
        agencyName: pan_name,
        panNumber,
        panUploaded,
        panInfo,
        businessType,
        address,
        state,
        city,
        pincode,
        gstNumber,
        kycDocType,
        kycUploaded,
        panVerified,
        facadeUploaded,
        panSuccess,
        pan_name,
        pan_type,
        user_msg,
        additionalDoc
      });
      uploadPanNumber(true);
    } else{
      uploadPanNumber();
    }
    setNameCorrectPop(false);
    setShowName(false);
  }

  return (
    <C.FormMainWrapper>
      <C.WelcomeHeadText>Business Details</C.WelcomeHeadText>
      <C.HeadSubText>We’ll need these to verify your account.</C.HeadSubText>
      <C.FormWrapper>
        <C.UserInfoForm onSubmit={submitInfo}>
          <C.BlockWrapper disabled={NON_EDITABLE_STATUS.indexOf(status) !== -1}>
            <C.InputWrapper>
              <S.AgencyWrapper>
                <C.CommonInputWrap>
                  <C.CommonInput
                    readOnly={!upload ? true : false}
                    type="text"
                    name="agencyName"
                    placeholder="Agency Name"
                    value={agencyName}
                    onChange={event => onChangeHandler('agencyName', event.target.value)}
                    onBlur={event => onChangeHandler('agencyName', event.target.value)}
                    hasError={errors['agencyName'] ? true : false}
                    onClick={onAgencyClick}
                  />
                  <C.ErrorText>{errors['agencyName']}</C.ErrorText>
                  {tooltipAgency ? EditToolTip : null}
                </C.CommonInputWrap>
              </S.AgencyWrapper>
            </C.InputWrapper>
            <S.KycPanWrapper>
              <S.PanBlockWrapper>
                <C.CommonInputWrap>
                  <C.CommonInput
                    isPAN
                    readOnly={!upload ? true : false}
                    type="text"
                    name="panNumber"
                    placeholder="Pan Number"
                    value={panNumber}
                    onChange={event => onChangeHandler('panNumber', event.target.value)}
                    onBlur={event => onChangeHandler('panNumber', event.target.value)}
                    hasError={errors['panNumber'] ? true : false}
                    onClick={onPanClick}
                    maxLength={10}
                  />
                  <C.ErrorText>{errors['panNumber']}</C.ErrorText>
                  {tooltipPan ? EditToolTip : null}
                </C.CommonInputWrap>
              </S.PanBlockWrapper>
              {uploadBlock}
            </S.KycPanWrapper>
            {(!isGSTBlockEnabled && (
              <C.ApiErrorText>
                {!panSuccess && apiErrorMsg && apiErrorMsg.screen === 'details' ? apiErrorMsg.msg : ''}
              </C.ApiErrorText>
            )) ||
              null}

            <S.GstOuterWrapper disabled={!isGSTBlockEnabled}>
              <S.GstInnerWrapper>
                <S.GstHeadTextWrap>
                  <S.GstHeadText>GSTIN Details</S.GstHeadText>
                </S.GstHeadTextWrap>
                <S.GstDisabelWrap>
                  <S.GstInCheckBox
                    type="checkbox"
                    checked={doNotHaveGSTIN}
                    onChange={toggleCheckBox}
                  ></S.GstInCheckBox>
                  <S.GstDisableText>Don't have GSTIN</S.GstDisableText>
                </S.GstDisabelWrap>
              </S.GstInnerWrapper>
              {!gstNumber &&
                <S.NoGstnMsg>No active GSTN found against the PAN {panNumber}. Please enter a valid GSTN below or select Don't have GSTIN</S.NoGstnMsg>
              || null }
              <S.KycPanWrapper>
                <S.PanBlockWrapper>
                  <C.CommonInputWrap>
                    {hasGSTINList && !doNotHaveGSTIN ? (
                      <S.FullDiv>
                        <GSTINSlectBox list={panInfo.gstin_list} />
                      </S.FullDiv>
                    ) : (
                      <C.CommonInput
                        disabled={doNotHaveGSTIN}
                        type="text"
                        name="gstNumber"
                        placeholder="GSTIN Number"
                        value={gstNumber}
                        onChange={event => onChangeHandler('gstNumber', event.target.value)}
                        hasError={errors['gstNumber'] ? true : false}
                      />
                    )}
                    <C.ErrorText>{errors['gstNumber']}</C.ErrorText>
                  </C.CommonInputWrap>
                </S.PanBlockWrapper>
                <S.PanBlockWrapper>
                  <C.CommonInputWrap>
                    {businessTypeList ? (
                      <S.FullDiv>
                        <BusinessTypeSelect />
                      </S.FullDiv>
                    ) : (
                      <C.CommonInput
                        type="text"
                        name="businessType"
                        placeholder="Business Type"
                        value={businessType}
                        onChange={event => onChangeHandler('businessType', event.target.value)}
                        hasError={errors['businessType'] ? true : false}
                      />
                    )}
                    <C.ErrorText>{errors['businessType']}</C.ErrorText>
                  </C.CommonInputWrap>
                </S.PanBlockWrapper>
              </S.KycPanWrapper>

              <C.InputWrapper>
                <C.CommonInputWrap>
                  <C.CommonInput
                    type="text"
                    name="address"
                    placeholder="Address"
                    value={address}
                    onChange={event => onChangeHandler('address', event.target.value)}
                    hasError={errors['address'] ? true : false}
                  />
                  <C.ErrorText>{errors['address']}</C.ErrorText>
                </C.CommonInputWrap>
              </C.InputWrapper>

              <C.InputWrapper disabled={pincodeDataLoading}>
                <S.StateCityWrapper>
                  <C.CommonInputWrap>
                    <S.InputPincode
                      type="text"
                      name="pincode"
                      placeholder="Pincode"
                      value={pincode}
                      onChange={event => onChangeHandler('pincode', event.target.value)}
                      onBlur={event => onPincodeBlur('pincode', event.target.value)}
                      hasError={errors['pincode'] ? true : false}
                      maxLength={6}
                    />
                    <C.ErrorText>{errors['pincode']}</C.ErrorText>
                  </C.CommonInputWrap>

                  <C.CommonInputWrap>
                    <S.InputCity
                      type="text"
                      name="city"
                      placeholder="City"
                      value={city}
                      disabled={disabelCity}
                      onChange={event => onChangeHandler('city', event.target.value)}
                      hasError={errors['city'] ? true : false}
                    />
                    <C.ErrorText>{errors['city']}</C.ErrorText>
                  </C.CommonInputWrap>

                  <C.CommonInputWrap>
                    <S.InputState
                      type="text"
                      name="state"
                      placeholder="State"
                      value={state}
                      disabled={disabelCity}
                      onChange={event => onChangeHandler('state', event.target.value)}
                      hasError={errors['state'] ? true : false}
                    />
                    <C.ErrorText>{errors['state']}</C.ErrorText>
                  </C.CommonInputWrap>
                </S.StateCityWrapper>
              </C.InputWrapper>

              {(showKYC && (
                <>
                  <S.KycPanWrapper>
                    <S.PanBlockWrapper>
                      <C.CommonInputWrap>
                        {kycDocList ? (
                          <KYCDocTypeSelect />
                        ) : (
                          <C.CommonInput
                            type="text"
                            name="kycDocType"
                            placeholder="KYC Document Type"
                            value={kycDocType}
                            onChange={event => onChangeHandler('kycDocType', event.target.value)}
                            hasError={errors['kycDocType'] ? true : false}
                          />
                        )}
                        <C.ErrorText>{errors['kycDocType']}</C.ErrorText>
                      </C.CommonInputWrap>
                    </S.PanBlockWrapper>
                    {kycUpload}
                  </S.KycPanWrapper>
                  <S.InfoNoteText>Supporting document should only be for your business/agency</S.InfoNoteText>
                </>
              )) ||
                null}

              {(addDocList && (
                <>
                  <S.KycPanWrapper>
                    <S.PanBlockWrapper>
                      <C.CommonInputWrap>
                        <AdditionalKYCDocTypeSelect />
                        <C.ErrorText>{errors['additionalDoc']}</C.ErrorText>
                      </C.CommonInputWrap>
                    </S.PanBlockWrapper>
                    {facadeUpload}
                  </S.KycPanWrapper>
                  <S.InfoNoteText>Supporting additional document should only be for your business/agency</S.InfoNoteText>
                </>
              )) ||
                null}
            </S.GstOuterWrapper>

            {(isGSTBlockEnabled && (
              <C.ApiErrorText>
                {apiErrorMsg && apiErrorMsg.screen === 'details' ? apiErrorMsg.msg : ''}
              </C.ApiErrorText>
            )) ||
              null}
          </C.BlockWrapper>

          <C.ButtonWrapper>
            <C.SignUpBtn type="submit">
              {setLoader || gstLoader ? <ButtonLoader loaderType="button" /> : 'NEXT'}
            </C.SignUpBtn>
          </C.ButtonWrapper>
        </C.UserInfoForm>
      </C.FormWrapper>

      {popVisible ?
        <>
          <C.PopOverlay />
          <PanUploader
            cancelEvent={cancelEvent}
            agreeEvent={agreeEvent}
            imgSrc={fileUrl}
          />
        </> : null}

        {popKycVisible ?
          <>
            <C.PopOverlay />
            <KYCUploader
              cancelEvent={cancelKycEvent}
              agreeEvent={agreeKycEvent}
              imgSrc={fileUrl}
            />
          </> : null
        }

        {popFacadeVisible ?
          <>
            <C.PopOverlay />
            <FacadeUploader
              cancelEvent={cancelFacadeEvent}
              agreeEvent={agreeFacadeEvent}
              imgSrc={fileUrl}
            />
          </> : null
        }

        {showName ?
          <>
            <C.PopOverlay />
            <NameCorrectSelect
              cancelEvent={cancelPanNameEvent}
              agreeEvent={agreeNameEvent}
              msg={user_msg}
            />
          </> : null
        }
    </C.FormMainWrapper>
  );
};

export default KycInfoUI;
